export default "/images/29fcc6a10635dea9c1df4760e5f3ba1d.avif";